import React, { useState, useEffect } from "react";
import "./login.scss";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { auth, firestoredb } from "../../../config";
import {
  GoogleAuthProvider,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLoginUser = async (e) => {
    // e.preventDefault();
    const validationError = Validation();

    if (!validationError.email && !validationError.password) {
      try {
        const userCred = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        // localStorage.setItem("isSigninSuccess", true);
        toast.success("Login success", { toastId: "userloggedin" });
        console.log(auth.currentUser);
        navigate("/")



      } catch (error) {
        console.log("Here")
        toast.error("Invalid Credentials", {
          toastId: "loginError",
        });
        toast("Hello")
      }
    }
  };

  const Validation = () => {
    let errorobj = { email: false, password: false };

    if (email === "") {
      errorobj.email = true;
    }
    if (email.length > 40) {
      errorobj.email = true;
    }

    if (password === "") {
      errorobj.password = true;
    }

    // setErrorObj(errorobj);
    return errorobj;
  };

  // useEffect(() => {
  //   // const auth = getAuth();
  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     if (user) {
  //       // User is signed in.
  //       const { uid } = user;
  //       navigate("/");
  //       // setUserisLogged(true);
  //     } else {
  //       // User is signed out.
  //       // setUserisLogged(false);

  //       // router.push({
  //       //     pathname: "/login",
  //       // });
  //     }
  //   });
  //   return () => unsubscribe();
  // }, []);

  return (
    <div>
      <div className="login">
        <div className="top">
          {/* <Icon icon="ri:openai-fill" width="40" height="40" /> */}
          <h1>MADIS</h1>
        </div>
        <div className="middle">
          <h3>Welcome back</h3>
          <input type="email" name="" id="" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input type="password" name="" id="" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />

          <div className="continue-btn" onClick={handleLoginUser}>
            <button>Continue</button>
          </div>
          <div className="sign-up">
            <p>
              Don't have an account?
              <Link to="/signup">
                <span>Sign up</span>
              </Link>
            </p>
          </div>
          <div className="or">
            <div className="left"></div>
            <p>OR</p>
            <div className="right"></div>
          </div>
          <div className="three-btn">
            <button>
              <Icon
                icon="flat-color-icons:google"
                color="white"
                width="30"
                height="30"
              />
              Continue with Google
            </button>
            {/* <button>
              <Icon
                icon="logos:microsoft-icon"
                color="white"
                width="30"
                height="30"
              />
              Continue with Microsoft Account
            </button>
            <button>
              <Icon icon="devicon:apple" color="white" width="30" height="30" />
              Continue with Apple
            </button> */}
          </div>
        </div>
        <div className="bottom">
          <p>Terms of use</p>
          <p>Privacy policy</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
